import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "highlightPersonalized",
})
export class HighlightPersonalizedPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.replace(
      /\{([^{}]+)\}/g,
      '<span class="highlight-personalized">{$1}</span>'
    );
  }
}
